import "./bootstrap";

// import './laravel-echo.js';

// 🌙 Dark Mode Store para Alpine.js (usando la instancia de Livewire)
document.addEventListener("livewire:init", () => {
    // Usar la instancia de Alpine que ya tiene Livewire
    if (window.Alpine) {
        window.Alpine.store("theme", {
            // Inicializar tema basado en localStorage o sistema
            theme:
                localStorage.getItem("theme") ||
                document.documentElement.getAttribute("data-theme") ||
                "system",

            get isDark() {
                if (this.theme === "system") {
                    return window.matchMedia("(prefers-color-scheme: dark)")
                        .matches;
                }
                return this.theme === "dark";
            },

            // Toggle entre los tres estados: system -> light -> dark -> system
            toggle() {
                if (this.theme === "system") {
                    this.theme = "light";
                } else if (this.theme === "light") {
                    this.theme = "dark";
                } else {
                    this.theme = "system";
                }
                this.updateDOM();
            },

            // Actualizar el DOM con data-theme
            updateDOM() {
                console.log("Actualizando tema a:", this.theme);
                if (this.theme === "system") {
                    localStorage.removeItem("theme");
                    document.documentElement.removeAttribute("data-theme");
                } else {
                    localStorage.setItem("theme", this.theme);
                    document.documentElement.setAttribute(
                        "data-theme",
                        this.theme
                    );
                }
                console.log(
                    "HTML actual:",
                    document.documentElement.outerHTML.substring(0, 150)
                );
            },

            // Inicializar el dark mode
            init() {
                this.updateDOM();

                // Escuchar cambios en la preferencia del sistema
                window
                    .matchMedia("(prefers-color-scheme: dark)")
                    .addEventListener("change", (e) => {
                        if (this.theme === "system") {
                            // Solo actualizar si estamos en modo sistema
                            this.updateDOM();
                        }
                    });
            },
        });

        // Inicializar el store
        window.Alpine.store("theme").init();
    }
});

// 🎭 Intersection Observer para animaciones
const observer = new IntersectionObserver(
    (entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add("visible");
                observer.unobserve(entry.target); // 🔥 anima una sola vez
            }
        });
    },
    { threshold: 0.2 }
);

document
    .querySelectorAll(".fade-section")
    .forEach((el) => observer.observe(el));
